import React from 'react';
import { LLQuizWidgetSubmitButton } from './LLQuizWidgetSubmitButton';
import { LLWidgetActionInfo, LLWidgetActionInfoProps } from '../LLWidgetFooter';

export function LLQuizWidgetActionInfo(props: LLWidgetActionInfoProps) {
  return (
    <LLWidgetActionInfo
      {...props}
      SubmitButtonComponent={LLQuizWidgetSubmitButton}
    />
  );
}
